export default __webpack_public_path__ + "static/media/dash_1.a8979483.png";